import type { RootState } from '@/store';

export const selectCentralAtendimentosStatus = (state: RootState) =>
  state.centralAtendimentos.status;

export const selectCentralAtendimentosError = (state: RootState) => state.centralAtendimentos.error;

export const selectResponsaveis = (state: RootState) => state.centralAtendimentos.responsaveis;

export const selectCurrentUserId = (state: RootState) => state.centralAtendimentos.currentUserId;

export const selectNegociacoes = (state: RootState) => state.centralAtendimentos.negociacoes;

export const selectNotificacoes = (state: RootState) => state.centralAtendimentos.notificacoes;

export const selectCasoIdDaNegociacao = (state: RootState, conversaId: string): string | null =>
  state.centralAtendimentos.negociacoes.find((item) => item.id === conversaId)?.casoId ?? null;

export const selectIsReabrindoNegociacao = (state: RootState) =>
  state.centralAtendimentos.isReabrindo;

export const selectCentralFiltros = (state: RootState) => state.centralAtendimentos.filtros;

export const selectCentralSelecao = (state: RootState) => state.centralAtendimentos.selecao;

export const selectCentralPaginacao = (state: RootState) => state.centralAtendimentos.paginacao;

export const selectCentralTotaisPendencia = (state: RootState) =>
  state.centralAtendimentos.totaisPendencia;

export const selectIsCarregandoMaisAtendimentos = (state: RootState) =>
  state.centralAtendimentos.isCarregandoMais;

export const selectCentralListDirtySeq = (state: RootState) =>
  state.centralAtendimentos.listDirtySeq;
